let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g19B6")).then(() => parcelRequire('bAoP2'));